/**
 * Created by yoyo on 2017/6/23.
 */
let Share = {
	wxShare: function(wx,oData){
		let that = this;
		oData.control.$http.post(oData.api,{url:encodeURIComponent(window.location.href.split('#')[0])}).then(function(res){
			let oConfig = res.body.data;
			wx.config({
				debug: false,
				appId: oConfig.wx_sign.app_key,
				timestamp: oConfig.wx_sign.timestamp,
				nonceStr: oConfig.wx_sign.noncestr,
				signature: oConfig.wx_sign.signature,
				jsApiList: [
					// 所有要调用的 API 都要加到这个列表中
					'onMenuShareTimeline',
					'onMenuShareAppMessage',
					'onMenuShareQQ',
					'onMenuShareWeibo'
				]
			});
			//微博分享配置
			window.WeiboJS.init({
				'debug': false,
				'appkey' : oConfig.wb_sign.app_key,
				'timestamp': oConfig.wb_sign.timestamp,
				'noncestr': oConfig.wb_sign.noncestr,
				'signature': oConfig.wb_sign.signature,
				'scope': [
					'setSharingContent'
				]
			});
			that.getShareData(wx,oData.shareInfo.share_title,oData.shareInfo.share_desc,oData.shareInfo.share_url,oData.shareInfo.share_img,oData.shareInfo.share_weibo);
		});
	},
	getShareData: function(wx,title_str,desc_str,link_str,img_url,weibo_desc){
		let shareData = {
			title : title_str,
			desc : desc_str,
			link : link_str,
			imgUrl : img_url,
		};
		//微信分享
		wx.ready(function () {
			// 在这里调用 API
			//分享到朋友圈
			wx.onMenuShareTimeline(shareData);
			//发送给朋友
			wx.onMenuShareAppMessage(shareData);
			//分享到QQ
			wx.onMenuShareQQ(shareData);
			//分享到腾讯微博
			wx.onMenuShareWeibo(shareData);
		});
		//微博分享
		window.WeiboJS.invoke("setSharingContent", {"icon": img_url, "title": title_str, "desc": weibo_desc});
	}
};
module.exports = Share;



// WEBPACK FOOTER //
// ./src/components/js/share.js